import React from 'react'
import Image from '../../../images/sellerpolicies/17.png'
import { Link } from 'react-router-dom'

const Return_and_replacement = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>RETURN AND REPLACEMENT </h2>
            <p>The Seller agrees that a customer may cancel an order for any Product in any category before it has been shipped to the Customer.</p>
            <p>The Seller authorizes KAAY to provide the Customer with a refund where the Customer has pre-paid for the Product and he/she cancels the order before it has been shipped or the Product is rejected and/or the Product is returned.</p>
            <p>The seller will accept the return packages for the following reason</p>
            <table>
                <tr>
                    <th>CUSTOMER RETURN REASON</th>
                    <th>EXAMPLE</th>
                </tr>
                <tr>
                    <th>Item is defective</th>
                    <td>- Shirt received that is not properly stitched.<br></br>- A bedsheet with a stain or improper printing of design.</td>
                </tr>
                <tr>
                    <th>I did not order this size</th>
                    <td>- Ordered medium received large</td>
                </tr>
                <tr>
                    <th>Item does not match description or picture</th>
                    <td>- Ordered while lawn stitched 3 pc suit with black lace at the bottom received the same 3pc with pink lace at the bottom.</td>
                </tr>
                <tr>
                    <th>I received the wrong item</th>
                    <td>- Ordered pants and received a shirt.</td>
                </tr>
                <tr>
                    <th>Item is counterfeit</th>
                    <td>- ordered a Zara shirt and received the first or any copy Zara shirt.</td>
                </tr>
            </table>
            <p>Given that the Product was shipped to the Customer from the seller and the Customer requests a replacement, the KAAY authorizes the seller to send a replacement Product to the Customer.</p>
            <p>The seller will be billed for the cost of shipping the replacement Product to the Customer only if the return claim is valid. In case the customer wants a replacement in the return claim the invalid customer will be billed for the cost of shipping.</p>
            <p>The Seller agrees to be bound by and act in accordance with the <Link to={'/sellerpolicies/return_and_replacement'}>Return Policy</Link>. To the extent that there is any conflict between the Return Policy, the <Link to={'/sellerpolicies/return_and_replacement'}>Return Policy</Link> shall prevail.</p>
        </div>
      </div>
    </div>
  )
}

export default Return_and_replacement
